import { PL_SHOTS_BASE } from './plShots';

export const DIAGNOSTICS_STATEMENT_BG_PLACEHOLDER = `${PL_SHOTS_BASE}/_TS_0145.jpg`;

export const DIAGNOSTICS_STATEMENT_BG_FALLBACK = '#737373';
